import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Payments from '../../../containers/Payments/Payments';

const TAB_PATHS = {
  records: 'records',
  disputes: 'disputes',
  settings: 'settings',
};

const PaymentsBase = () => (
  <Routes>
    <Route>
      {Object.keys(TAB_PATHS).map((path) => (
        <Route exact path={path} key={path} element={<Payments tab={TAB_PATHS[path]} />} />
      ))}
      <Route
        exact
        path="/experiential-reward-details"
        element={<Payments tab="records" subTab="experiential-reward-details" />}
      />
      <Route exact path="/disputes/:id" element={<Payments tab="disputes" subTab="dispute-details" />} />
    </Route>
  </Routes>
);

export default PaymentsBase;
